import {useSelector} from 'react-redux';
import {RootState} from '../../member/store';

export const useTags = () => {
  const {tags} = useSelector((state: RootState) => {
    return state.notifications;
  });
  return tags;
};
